import { Link } from "react-router-dom";
import { BookOpen, ArrowRight } from "lucide-react";
import { Seo } from "../components/Seo";
import { PublicLayout, OpenGeneratorButton } from "../components/PublicLayout";
import site from "../content/site.json";

const G = site.guides;

function fmt(d) {
  try {
    return new Date(d).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" });
  } catch {
    return d;
  }
}

export default function GuidesIndex() {
  return (
    <PublicLayout>
      <Seo title={G.title} description={G.description} path="/guides" />

      <section className="max-w-4xl mx-auto px-4 sm:px-6 pt-14">
        <span className="inline-flex items-center gap-2 rounded-full border border-[#22D3EE]/30 bg-[#22D3EE]/10 px-3 py-1 text-xs font-semibold text-[#8BE8F5]">
          <BookOpen className="w-3.5 h-3.5" /> Guides
        </span>
        <h1 className="mt-5 font-heading text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-50">
          {G.h1}
        </h1>
        <p className="mt-4 text-slate-300 max-w-2xl">{G.intro}</p>
      </section>

      <section className="max-w-4xl mx-auto px-4 sm:px-6 py-12 grid grid-cols-1 sm:grid-cols-2 gap-5">
        {G.items.map((g) => (
          <Link
            key={g.slug}
            to={`/guides/${g.slug}`}
            data-testid={`guide-card-${g.slug}`}
            className="group rounded-2xl border border-[#1E2C48] bg-[#0D1424] p-6 hover:border-[#22D3EE]/50 transition-colors"
          >
            <p className="text-xs text-slate-500">{fmt(g.date)}</p>
            <h2 className="mt-2 font-heading text-lg font-semibold text-slate-50 group-hover:text-[#22D3EE] transition-colors">
              {g.title}
            </h2>
            <p className="mt-2 text-sm text-slate-400 leading-relaxed">{g.excerpt}</p>
            <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-[#D4AF37]">
              Read guide <ArrowRight className="w-4 h-4" />
            </span>
          </Link>
        ))}
      </section>

      <section className="max-w-4xl mx-auto px-4 sm:px-6 pb-16">
        <div className="rounded-3xl border border-[#1E2C48] bg-gradient-to-br from-[#0D1424] to-[#121B30] p-8 text-center">
          <h2 className="font-heading text-2xl font-bold text-slate-50">Put it into practice</h2>
          <p className="mt-3 text-slate-400">Open the generator and build your next Suno song prompt.</p>
          <div className="mt-6 flex justify-center">
            <OpenGeneratorButton testId="guides-open-generator" label="Open Song Generator" className="h-12 px-7 text-base" />
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
